<template>
  <el-select
    :style="style"
    v-model="val"
    :placeholder="placeholder"
    :multiple="multiple"
    :size="size"
    default-first-option
    filterable
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-option
      v-for="(item, index) in opts"
      :key="index"
      :label="item.label"
      :value="item.value"
      :disabled="item.disabled"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  name: 'form-select',
  props: {
    width: {
      type: [Number, String],
      default: '100%',
    },
    options: [Array, Function],
    value: { required: true },
    placeholder: {
      type: String,
      default() {
        switch (this.$root.getCurrentLang()) {
          case 'CN':
            return '请选择'
          default:
            return 'Please select'
        }
      },
    },
    multiple: Boolean,
    join: String,
    size: {
      type: String,
      default: 'small',
    },
  },
  model: {
    prop: 'value',
    event: 'setval',
  },
  computed: {
    opts() {
      if (typeof this.options == 'function') return this.options()
      return this.options
    },
    style() {
      var ret = {
        width: '100%',
      }
      switch (typeof this.width) {
        case 'number':
          ret.width = this.width + 'px'
          break
        case 'string':
          ret.width = this.width
          break
      }
      return ret
    },
    isJoin() {
      return this.multiple && !!this.join
    },
    val: {
      get() {
        if (this.isJoin) {
          return this.value ? this.value.split(this.join) : []
        }
        return this.value
      },
      set(newVal) {
        var data = newVal
        if (this.isJoin) {
          data = data.join(this.join)
        }
        this.$emit('setval', data)
      },
    },
  },
}
</script>

<style>
</style>
